import { render } from "./LoginAudits.vue?vue&type=template&id=01f04b89&scoped=true"
import script from "./LoginAudits.vue?vue&type=script&lang=js"
export * from "./LoginAudits.vue?vue&type=script&lang=js"

import "./LoginAudits.vue?vue&type=style&index=0&id=01f04b89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f04b89"]])

export default __exports__